import axios from '../../../build/http-requests/axios-common'

export default {
  state: {
  },

  mutations: {
  },

  actions: {
    searchFiles: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.post('/processedFiles/search', data).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getProcessedFiles: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.get(data.url, { params: { procId: data.idProcessamento } })
          .then(response => {
            resolve(response.data)
          }).catch((error) => {
            reject(error)
          })
      })
    }
  },

  getters: {
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/processedFiles.js